module.exports = __webpack_public_path__ + "media/images/ww100-6afb269ed25a033ab3010418391ee0c2.svg";